import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/finally';
import { LoaderService } from './loader.service';
import { UtilitiesService } from './utilities.service';

// constant

const APIList = {
  // server URL
  "userconsent"         : "app/consent",
  "consentconfirm"      : "app/consent/confirm",
  "consentHandle"       : "app/consent",
  "consentUpdate"       : "app/consent/update",

  "accountdiscover"     : "app/accounts/discover",
  "accountlink"         : "app/accounts/link",
  "accountDelink"       : "app/accounts/delink",
  "accountlinkconfirm"  : "app/accounts/confirm-token",

  "dashboard"           : "app/dashboard",
  "notification"        : "aa/notification",
  "banklogo"            : "bankList",
  "userIdentifier"      : "app/user/identifier",
  "fipList"             : "app/fip",
  "fiuList"             : "app/fiu",

  "changeconsentpin"    : "app/consent/pin",
  "createconsentpin"    : "app/consent/pin",

  "consentHistory"      : "app/consent/history",
  "consentTimeline"     : "app/consent/history",

  "userInfo"            : "app/user/info",
  "bankIdentifier"      : "app/fipidentifiertypes",
  "accountotp"          : "app/accounts/otp"
};

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  url: string;
  serverUrl: string;
  localUrl: string;
  developerUrl: string;
  headers: any;
  constructor(private http: HttpClient, private loader: LoaderService, private utils: UtilitiesService) {
    this.localUrl     = 'assets/jsonFiles/';
    this.serverUrl    = 'https://aa.onemoney.in/';
    this.developerUrl = 'https://aa.onemoney.in/';
    // this.serverUrl    = 'http://localhost:3000/';
    // this.developerUrl = 'http://localhost:3000/';
  }

  /**
   * 
   * @param options - object for Http Request 
   * options={
   * type   : enum('GET','POST','PUT','DELETE'),
   * url    : string [httpUrl keyword],
   * isLocal: boolean [local API call or server call (optional)]
   * isDeveloper:boolean [developer API call or server call (optional)]
   * data   : json [data for post or put call]
   * }
   */
  makeHttpRequest(options) {
    //Showing loader
    this.toggleLoader(true);

    this.url = this.getApiUrl(options);
    
    this.headers = this.requestHeader(options);
  
    if (options.type.toLowerCase() == 'post') {
      return this.http.post(this.url, options.data, this.headers).map(res => res)
        .finally(() => {
        this.toggleLoader(false);
      });
    } else if (options.type.toLowerCase() == 'put') {
      return this.http.put(this.url, options.data, this.headers).map(res => res)
        .finally(() => {
        this.toggleLoader(false); 
      });
    } else if (options.type.toLowerCase() == 'delete') {
      return this.http.delete(this.url, this.headers).map(res => res)
        .finally(() => {
        this.toggleLoader(false); 
      });
    } else {
      return this.http.get(this.url, this.headers).map(res => res).finally(() => {
        this.toggleLoader(false);
      });
    }
  }

  /**
   * 
   * @param options :{Object}
   * options={
   * type   : enum('GET','POST','PUT','DELETE'),
   * url    : string [httpUrl keyword],
   * isLocal: boolean [local API call or server call (optional)]
   * isDeveloper: boolean [development URL],
   * pathVariables:Array for path Variables
   * data   : json [data for post or put call]
   * }
   */

  getApiUrl(options) {
    if (options.url) {
      let url;
      // local APi call
      if (APIList[options.url]) {
        if ((options.isLocal != undefined) && (options.isLocal == true)) {

          url = this.localUrl + APIList[options.url] + ".json";
        } else if ((options.isDeveloper != undefined) && (options.isDeveloper == true)) {

          url = this.developerUrl + APIList[options.url];
        } else { //server Call
          url = this.serverUrl + APIList[options.url];
        }
        if (!options.isLocal && options.pathVariables) {
          options.pathVariables.forEach(element => {
            url += '/' + element;
          });
        }
        return url;
      } else {
        console.log("Path could not be found in the list");
        return "Path could not be found in the list";
      }
    } else {
      console.log("Path not Defined");
      return "Path not Defined";
    }
  }

  requestHeader(options) {
    let header;
    var sessionId = this.utils.getItemFromLocalStorage('usersession');
    header = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    if(options.includeUserSession) {
      header = new HttpHeaders({
        'sessionId': sessionId,
        'Content-Type': 'application/json'
      });
    } else {
      header = new HttpHeaders({
        'Content-Type': 'application/json',
      });
    }
    return { headers: header };
  }
  errorHandler(obj) {
  }

  /**
   * @desc To toggle the loader visibility
   * @param  {boolean} flag
   */
  toggleLoader(flag) {
    this.loader.toggleLoader(flag);
  }
}
